import ComingSoonPage from "../../components/ComingSoonPage";
import AppShell from '../../components/AppShell';

export default function MeetMate() {
  return (
    <AppShell>
      <div className="lg:col-span-8 space-y-6 text-center">
    <ComingSoonPage
      appName="Meet Mate AI"
      teaser="Summarize meetings, track action items, and get auto follow-ups."
      imageSrc="/images/coming-soon/meetmate.png"
    />
    </div>
    </AppShell>
  );
}

